/**
 * The filters duck. This is where information about sorting and filtering is stored.
 * Default export is the reducer.
 */

import type { Action } from '../types';
import { PACKAGES_FETCH_SUCCEEDED } from './packages';
import { CARD_FILTER_MODAL_OPENED } from './modals';

/** @type {ActionType} */
export const FILTERS_OPENED = 'PB/filters/FILTERS_OPENED';
/** @type {ActionType} */
export const FILTERS_FINISHED = 'PB/filters/FILTERS_FINISHED';
/** @type {ActionType} */
export const FILTERS_CLOSED = 'PB/filters/FILTERS_CLOSED';
/** @type {ActionType} */
export const UPDATE_FLYER_FILTERS = 'PB/filters/UPDATE_FLYER_FILTERS';

export const initialState = {
  cardFilters: {
    sort: '',
    filterGroups: [],
  },
  flyerFilters: {
    filterGroups: [],
    flyerResults: 0,
  },
};

export default function filters(
  state: Object = initialState,
  action: Action<string, Object>,
): Object {
  let payload = action.payload || {};

  switch (action.type) {
    case PACKAGES_FETCH_SUCCEEDED:
      const { sort, filters: cardsFilterGroups } = payload;
      return {
        ...state,
        cardFilters: { sort, filterGroups: cardsFilterGroups },
      };

    case UPDATE_FLYER_FILTERS:
      const { filters: flyersFilterGroups, flyerResults } = payload;
      return {
        ...state,
        flyerFilters: { filterGroups: flyersFilterGroups, flyerResults },
      };

    default:
      return state;
  }
}

export function updateFlyerFilters(filters, totalItems) {
  return {
    type: UPDATE_FLYER_FILTERS,
    payload: { filters, flyerResults: totalItems },
  };
}
